export default __webpack_public_path__ + "static/sandy2-e2437e8318abc4c8de13d34b40a29cdb.png";